import Store from '@/Store';
import { NavigationGuardNext, Route } from 'vue-router';

/**
 * Handles social media redirections to authenticate our user.
 *
 * @return void
 */
export function Authentication(to: Route, from: Route, next: NavigationGuardNext): void {
	if (jwtExists(to)) {
		// Attempt to log a user in from Google
		Store.dispatch('login', {
			jwt: to.query.jwt,
		});

		// Remove the JWT from the URL
		next({ path: to.path });

		return;
	}

	next();
}

/**
 * Checks if a jwt exists in the URL
 *
 * @param Route to
 * @return boolean
 */
function jwtExists(to: Route): boolean {
	return !!(to.query.jwt?.toString() || '');
}
